import type { FC } from 'react';

import { Typography, Button } from '@mui/material';

import styles from './styles.module.css';

type DefaultErrorPresenterProps = {
  reload: () => void;
};

export const DefaultErrorPresenter: FC<DefaultErrorPresenterProps> = ({
  reload,
}) => {
  return (
    <div className={styles.root}>
      <div className={styles.notification_container}>
        <Typography variant="h5">
          ブラウザをリロードして再度お試しください。
          <br />
          しばらく経っても復旧しない場合は、お手数ですが担当者までご連絡ください。
        </Typography>
        <Button
          variant="contained"
          color="primary"
          className={styles.button}
          onClick={reload}
        >
          リロードする
        </Button>
      </div>
    </div>
  );
};
